import { render, staticRenderFns } from "./ConferenceDescription.vue?vue&type=template&id=385994be&"
import script from "./ConferenceDescription.vue?vue&type=script&lang=js&"
export * from "./ConferenceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports